import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "reprintCertificates";
export var useReprintCertificates = function () {
    var dispatch = useDispatch();
    var loadingReprintCertificates = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var responseReprintCertificates = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var errorReprintCertificates = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var reprintCertificates = function (quoteId) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "POST",
            path: "/asg/Api/V1/Quote/".concat(quoteId, "/Reprint"),
        }));
    };
    var clearReprintCertificates = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        reprintCertificates: reprintCertificates,
        clearReprintCertificates: clearReprintCertificates,
        loadingReprintCertificates: loadingReprintCertificates,
        responseReprintCertificates: responseReprintCertificates,
        errorReprintCertificates: errorReprintCertificates,
    };
};
